import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submitForgot = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const submitReset = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/auth/reset-password", { token, password });
      toast.success(t("auth.reset.btn") + " ✓");
      navigate("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (token) {
    return (
      <div className="mx-auto max-w-md px-4 py-16" data-testid="reset-password-page">
        <h1 className="font-display text-3xl font-semibold">{t("auth.reset.title")}</h1>
        <form onSubmit={submitReset} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="np">{t("auth.password")}</Label>
            <Input id="np" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="reset-submit-button">{t("auth.reset.btn")}</Button>
        </form>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md px-4 py-16" data-testid="forgot-password-page">
      <h1 className="font-display text-3xl font-semibold" data-testid="forgot-title">{t("auth.forgot.title")}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t("auth.forgot.sub")}</p>
      {done ? (
        <div className="mt-8 rounded-xl border border-border bg-card p-5 text-sm" data-testid="forgot-success">
          If that email exists, a reset link has been created. (Email delivery is not configured in this environment — contact your administrator.)
          <div className="mt-3"><Link to="/login" className="font-medium text-primary hover:underline">{t("auth.have.account")}</Link></div>
        </div>
      ) : (
        <form onSubmit={submitForgot} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="fe">{t("auth.email")}</Label>
            <Input id="fe" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-submit-button">{t("auth.forgot.btn")}</Button>
        </form>
      )}
    </div>
  );
}
